import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100 bg-white",
    style: { "z-index": "10", "opacity": "0.8" }
};
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "col-md-6" };
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_7 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_8 = { class: "col-md-6" };
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = ["placeholder"];
const _hoisted_12 = { class: "col-md-6" };
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_15 = ["placeholder"];
const _hoisted_16 = { class: "col-md-6" };
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_19 = ["placeholder"];
const _hoisted_20 = { class: "col-md-6" };
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_22 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_23 = { class: "input-group" };
const _hoisted_24 = ["value"];
const _hoisted_25 = ["placeholder"];
const _hoisted_26 = { class: "col-md-6" };
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_28 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_29 = ["placeholder"];
const _hoisted_30 = { class: "col-md-6" };
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_32 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_33 = ["placeholder"];
const _hoisted_34 = { class: "col-md-6" };
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_36 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_37 = ["placeholder"];
const _hoisted_38 = { class: "col-md-12" };
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_40 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_41 = ["placeholder"];
const _hoisted_42 = { class: "col-md-12" };
const _hoisted_43 = { class: "d-flex justify-content-end gap-2" };
const _hoisted_44 = ["disabled"];
const _hoisted_45 = { key: 0 };
const _hoisted_46 = { key: 1 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(_component_LoaderComponent)
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("form", {
                onSubmit: _cache[11] || (_cache[11] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.handleSave && _ctx.handleSave(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('forms.civility')) + " * ", 1),
                            _withDirectives(_createElementVNode("select", {
                                class: "form-control shadow-none rounded-0 text-black",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.customerData.civilite) = $event)),
                                required: ""
                            }, [...(_cache[12] || (_cache[12] = [
                                    _createElementVNode("option", { value: "" }, "-- " + _toDisplayString('Sélectionner') + " --", -1),
                                    _createElementVNode("option", { value: "monsieur" }, "Monsieur", -1),
                                    _createElementVNode("option", { value: "madame" }, "Madame", -1)
                                ]))], 512), [
                                [_vModelSelect, _ctx.customerData.civilite]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('forms.firstName')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('forms.firstName'),
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.customerData.firstName) = $event)),
                                required: ""
                            }, null, 8, _hoisted_11), [
                                [_vModelText, _ctx.customerData.firstName]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('forms.lastName')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('forms.lastName'),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.customerData.lastName) = $event)),
                                required: ""
                            }, null, 8, _hoisted_15), [
                                [_vModelText, _ctx.customerData.lastName]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('forms.email')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "email",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('forms.email'),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.customerData.email) = $event)),
                                required: ""
                            }, null, 8, _hoisted_19), [
                                [_vModelText, _ctx.customerData.email]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('forms.phone')) + " * ", 1),
                            _createElementVNode("div", _hoisted_23, [
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.customerData.phoneCountryCode) = $event)),
                                    class: "form-select shadow-none fw-semibold rounded-0",
                                    style: { "max-width": "140px" }
                                }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneCountryCodes, (country) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: country.code,
                                            value: country.code
                                        }, _toDisplayString(country.flag) + " " + _toDisplayString(country.prefix), 9, _hoisted_24));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, _ctx.customerData.phoneCountryCode]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control shadow-none rounded-0 text-black",
                                    placeholder: _ctx.$t('forms.phone'),
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.customerData.phoneNumber) = $event)),
                                    required: ""
                                }, null, 8, _hoisted_25), [
                                    [_vModelText, _ctx.customerData.phoneNumber]
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('order.street')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('order.street'),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.customerData.address) = $event)),
                                required: ""
                            }, null, 8, _hoisted_29), [
                                [_vModelText, _ctx.customerData.address]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('pos.streetNumber')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('pos.streetNumber'),
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.customerData.numeroRue) = $event)),
                                required: ""
                            }, null, 8, _hoisted_33), [
                                [_vModelText, _ctx.customerData.numeroRue]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('order.locality')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('order.locality'),
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.customerData.city) = $event)),
                                required: ""
                            }, null, 8, _hoisted_37), [
                                [_vModelText, _ctx.customerData.city]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('order.postalCode')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control shadow-none rounded-0 text-black",
                                placeholder: _ctx.$t('order.postalCode'),
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.customerData.codePostal) = $event)),
                                required: ""
                            }, null, 8, _hoisted_41), [
                                [_vModelText, _ctx.customerData.codePostal]
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-secondary",
                                onClick: _cache[10] || (_cache[10] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goBack && _ctx.goBack(...args)))
                            }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "btn btn-primary",
                                disabled: _ctx.isSaving
                            }, [
                                (_ctx.isSaving)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.$t('common.saving')) + "...", 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.$t('common.save')), 1))
                            ], 8, _hoisted_44)
                        ])
                    ])
                ])
            ], 32)
        ])
    ]));
}
